@if (appliedFilters()) {
  @if (filter()) {
    <div>
      <h1 class="tracking-wider">
        @if (filter().displayName) {
          {{ filter().displayName }}
        } @else {
          {{ filter().name | humanize }}
        }
      </h1>
      @if (filter().type === "dropdown") {
        <div>
          <ng-select
            [items]="filter().options"
            [multiple]="true"
            [maxSelectedItems]="filter().maxSelectedItems || 'none'"
            [required]="$safeNavigationMigration(filter?.required)"
            [searchable]="true"
            [virtualScroll]="true"
            [hideSelected]="true"
            [addTag]="filter().canAddItem ? addCustomItem : false"
            [placeholder]="dropdownPlaceholder"
            [ngModel]="dropdown"
            (change)="dropdown = $event"
            (click)="$event.stopImmediatePropagation()"
            appendTo="body"
            [disabled]="disabled()"
            [groupBy]="$safeNavigationMigration(filter?.groupName)"
          />
        </div>
      }
      @if (filter().type === "dropdown-single") {
        <div>
          <ng-select
            [items]="filter().options"
            [multiple]="false"
            [required]="$safeNavigationMigration(filter?.required)"
            [searchable]="true"
            [virtualScroll]="true"
            [addTag]="filter().canAddItem ? addCustomItem : false"
            [placeholder]="dropdownPlaceHolderSingle"
            [ngModel]="dropdown ? dropdown[0] : null"
            (change)="dropdown = $event"
            (click)="$event.stopImmediatePropagation()"
            appendTo="body"
            [disabled]="disabled()"
            [groupBy]="$safeNavigationMigration(filter?.groupName)"
          />
        </div>
      }
      @if (filter().type === "week") {
        <div class="grow" (click)="$event.stopImmediatePropagation()">
          <ag1-week-range
            [startWeek]="startWeek"
            [endWeek]="endWeek"
            separator="to"
            (startWeekChange)="startWeek = $event ?? ''"
            (endWeekChange)="endWeek = $event ?? ''"
          />
        </div>
      }
      @if (filter().type === "dateRange") {
        <div (click)="$event.stopPropagation()">
          <ag1-date-range
            [clearable]="!filter?.locked"
            [startDate]="startDateRange"
            [endDate]="endDateRange"
            [showPresetSelection]="showPresetSelection()"
            [selectedPresetOption]="
              filter().selectedPresetOption || dateRangePresetOption
            "
            (startDateChange)="startDateRange = $event"
            (endDateChange)="endDateRange = $event"
            (presetOptionChange)="onDateRangePresetOptionChange($event)"
          />
        </div>
      }
      @if (filter().type === "text") {
        <div>
          <input
            class="min-w-min"
            [ngModel]="text"
            (ngModelChange)="text = $event"
            name="text"
            type="text"
            placeholder="Enter {{ filter().name }}"
          />
        </div>
      }
      @if (filter().type === "number") {
        <div>
          <input
            class="min-w-min"
            [ngModel]="number"
            (ngModelChange)="number = $event"
            name="number"
            type="number"
            placeholder="Enter {{ filter().name }}"
          />
        </div>
      }
    </div>
  }
}
